import { AVATAR_FONT_STYLES_RECORD } from '../constants/font.mjs';
import { isAvatarPresetSize } from './cast.mjs';
import { getRelativeSizeRange } from './size.mjs';

function getAvatarFontStyles(size) {
  if (isAvatarPresetSize(size)) {
    return AVATAR_FONT_STYLES_RECORD[size];
  }
  const relativeSizeRange = getRelativeSizeRange(size);
  const { fontSize, fontWeight } = AVATAR_FONT_STYLES_RECORD[relativeSizeRange];
  const restrictedFontSize = size >= 60 ? Math.min(32, Math.floor(size / Math.log(24))) : fontSize;
  return { fontSize: restrictedFontSize, fontWeight };
}

export { getAvatarFontStyles };
//# sourceMappingURL=font.mjs.map
